export default {
  components: {
    findOutMore: {
      freeDessert: 'Postre gratis',
      freeDessertNextVisit: 'Postre gratis en vuestra próxima visita',
      iWorkHard: 'Trabajo duro para hacer su tiempo lo más agradable posible; por favor, califique mi servicio',
      weAlwaysWantToDoBetter: 'Siempre deseamos mejorar, por favor, espere mientras preparamos unas preguntas para vuestros comentarios',
      weJustNeedOneMinuteOfYourTime: 'Solo necesitamos un minuto de vuestro tiempo',
      youWillBeAskedAFewQuestions: 'Se le harán algunas preguntas acerca de vuestra experiencia',
      yourFeedbackWillGoDirectlyToMe: 'Vuestros comentarios irán directamente a mi persona'
    }
  }
};